import {
  AgendaSpeaker,
  PublicEventDetailsResponse,
} from '@hubs101/booking-api-skd-client/lib/types';
import { Image, Text, View } from '@react-pdf/renderer';
import { getImageSrc, getSpeakerFullName } from '@utils/fn';

import { useTranslation } from 'react-i18next';
import { globalStyles } from '../../styles';
import { styles } from './styles';
import { SafeImage } from '../SafeImage';

interface ModeratorsProps {
  event: PublicEventDetailsResponse;
  agendaSpeakers: AgendaSpeaker[];
}

const Moderators = ({ event, agendaSpeakers }: ModeratorsProps) => {
  const { t } = useTranslation();

  return (
    <View
      style={{
        ...globalStyles.body,
      }}
    >
      <Text
        style={{
          ...globalStyles.mediumTitle,
          color: event?.design?.themeColor,
        }}
      >
        {t('speakers-&-moderators')}
      </Text>

      <View
        style={{
          ...globalStyles.lineBar,
          borderColor: event?.design?.themeColor,
        }}
      />

      <View style={styles.moderatorsWrapper}>
        {agendaSpeakers
          ?.filter(speaker => {
            return (
              speaker?.first_name &&
              speaker?.last_name &&
              speaker?.job?.title &&
              speaker?.company?.name &&
              speaker?.company?.logo
            );
          })
          ?.map(speaker => {
            const speakerFullName = getSpeakerFullName(
              speaker?.first_name,
              speaker?.last_name
            );
            const speakerJobCompany = [
              speaker?.job?.title,
              speaker?.company?.name,
            ]
              ?.filter(Boolean)
              .join(', ');

            return (
              <View
                style={styles.moderatorItemWrapper}
                wrap={false}
                key={speaker.profile}
              >
                <View style={styles.moderatorImagesWrapper}>
                  {speaker?.company?.logo?.length > 0 && (
                    <SafeImage
                      style={styles.companyLogo}
                      src={getImageSrc(speaker?.company?.logo)}
                      debugLabel={`moderator-company-logo-${speaker.profile}`}
                    />
                  )}
                </View>
                <View style={styles.moderatorDetailsWrapper}>
                  <Text style={styles.speakerCompanyName}>
                    {speakerJobCompany}
                  </Text>
                  <Text style={styles.speakerName}>{speakerFullName}</Text>
                </View>
              </View>
            );
          })}
      </View>
    </View>
  );
};

export default Moderators;
